import { __extends } from "tslib";
import { MDCRipple } from '@material/ripple';
import { getShadowElement, Platform, removeAllChildren, removeElement } from '@tyler-components-web/core';
import { BaseAdapter } from '../../core/adapters/base-adapter';
import { PRODUCT_ICON_CONSTANTS } from '../../product-icon';
import { VIEW_SWITCHER_CONSTANTS } from '../../view-switcher';
import { APP_LAUNCHER_CONSTANTS } from './app-launcher-constants';
import { ICON_CLASS_NAME } from '../../constants';
var AppLauncherAdapter = /** @class */ (function (_super) {
    __extends(AppLauncherAdapter, _super);
    function AppLauncherAdapter(component) {
        var _this = _super.call(this, component) || this;
        _this._rootElement = getShadowElement(_this._component, APP_LAUNCHER_CONSTANTS.selectors.ROOT);
        _this._viewSwitcher = getShadowElement(_this._component, VIEW_SWITCHER_CONSTANTS.elementName);
        _this._optionsContainer = getShadowElement(_this._component, APP_LAUNCHER_CONSTANTS.selectors.OPTIONS_CONTAINER);
        _this._inputElement = getShadowElement(_this._component, APP_LAUNCHER_CONSTANTS.selectors.SEARCH_INPUT);
        _this._titleElement = getShadowElement(_this._component, APP_LAUNCHER_CONSTANTS.selectors.TITLE);
        _this._searchContainer = getShadowElement(_this._component, APP_LAUNCHER_CONSTANTS.selectors.SEARCH_CONTAINER);
        return _this;
    }
    AppLauncherAdapter.prototype.setView = function (view) {
        this._viewSwitcher.index = view;
    };
    AppLauncherAdapter.prototype.setOptions = function (options, listener) {
        this._setOptions(options, this._optionsContainer, listener);
    };
    AppLauncherAdapter.prototype._setOptions = function (options, container, listener) {
        var gridElement = container.querySelector(APP_LAUNCHER_CONSTANTS.selectors.GRID);
        removeAllChildren(gridElement);
        var rowNum = 1;
        for (var _i = 0, options_1 = options; _i < options_1.length; _i++) {
            var option = options_1[_i];
            var element = this._createOption(option, listener);
            gridElement.appendChild(element);
            // Add support for grid in IE by setting the column and row positions
            if (Platform.TRIDENT) {
                var index = options.indexOf(option);
                var column = (index + 1) % 4 || 4;
                element.style.setProperty('-ms-grid-column', column.toString());
                element.style.setProperty('-ms-grid-row', rowNum.toString());
                if (column % 4 === 0) {
                    rowNum++;
                }
            }
        }
    };
    AppLauncherAdapter.prototype._createOption = function (option, listener) {
        var container = document.createElement('div');
        container.classList.add(APP_LAUNCHER_CONSTANTS.classes.GRID_ITEM);
        container.tabIndex = 0;
        container.addEventListener('click', function () { return listener(option); });
        container.addEventListener('keydown', function (evt) {
            if (evt.key === 'Enter' || evt.keyCode === 13) {
                listener(option);
            }
        });
        MDCRipple.attachTo(container);
        var iconElement;
        if (option.icon && (option.icon.name || option.icon.uri)) {
            var type = option.icon.type || '';
            switch (type.toLowerCase()) {
                case 'svg':
                case 'image':
                    iconElement = this._createImageIcon(option.icon.uri);
                    break;
                case 'font':
                default:
                    iconElement = this._createFontIcon(option.icon.name, option.icon.color, option.icon.fontClass);
                    break;
            }
        }
        else if (option.iconURI) {
            if (option.iconURI.lastIndexOf('.') >= 0) {
                iconElement = this._createImageIcon(option.iconURI);
            }
            else {
                iconElement = this._createFontIcon(option.iconURI);
            }
        }
        else {
            iconElement = this._createFontIcon();
        }
        container.appendChild(iconElement);
        var label = document.createElement('div');
        label.classList.add(APP_LAUNCHER_CONSTANTS.classes.GRID_ITEM_TITLE);
        label.textContent = option.label;
        container.appendChild(label);
        return container;
    };
    AppLauncherAdapter.prototype._createFontIcon = function (name, color, fontClass) {
        var productIcon = document.createElement(PRODUCT_ICON_CONSTANTS.elementName);
        productIcon.size = 48;
        if (color) {
            productIcon.color = color;
        }
        var iElement = document.createElement('i');
        iElement.classList.add(fontClass ? fontClass : ICON_CLASS_NAME);
        iElement.textContent = name || APP_LAUNCHER_CONSTANTS.strings.DEFAULT_FONT_ICON_NAME;
        productIcon.appendChild(iElement);
        return productIcon;
    };
    AppLauncherAdapter.prototype._createImageIcon = function (uri) {
        var img = document.createElement('img');
        img.src = uri;
        return img;
    };
    AppLauncherAdapter.prototype.focusFirstOption = function () {
        if (this._inputElement.isConnected) {
            this._inputElement.focus();
        }
        else {
            var gridItems = Array.from(this._rootElement.querySelectorAll(APP_LAUNCHER_CONSTANTS.selectors.GRID_ITEM));
            if (gridItems && gridItems.length) {
                gridItems[0].focus();
            }
        }
    };
    AppLauncherAdapter.prototype.addInputListener = function (type, listener) {
        this._inputElement.addEventListener(type, listener);
    };
    AppLauncherAdapter.prototype.removeInputListener = function (type, listener) {
        this._inputElement.removeEventListener(type, listener);
    };
    AppLauncherAdapter.prototype.setTitle = function (value) {
        this._titleElement.textContent = value;
    };
    AppLauncherAdapter.prototype.hideSearch = function () {
        removeElement(this._searchContainer);
    };
    return AppLauncherAdapter;
}(BaseAdapter));
export { AppLauncherAdapter };
